import styled from 'styled-components';

import { colors, fontFamily, zIndex } from '../../ui/variables';

const main = {
  height: {
    iphone: 50,
  },
};

export const SelectOptionsStyle = styled.div`
  position: relative;
  z-index: ${zIndex.space}; 
  &.light-theme {
    .select-container {
      background-color: ${colors.mostlyWhite};
      border: solid 1px ${colors.mostlyWhite};
      color: ${colors.veryDarkGrayishBlue};

      .icon {
        background-color: ${colors.mostlyWhite};

        svg {
          fill: ${colors.veryDarkGrayishBlue};
        }
      }
    }
  }

  &.dark-theme,
  &.default-theme {
    .select-container {
      background-color: ${colors.veryDarkGrayishBlue};
      border: solid 1px ${colors.veryDarkGrayishBlue};
      color: ${colors.mostlyWhite};

      .icon {
        background-color: ${colors.veryDarkGrayishBlue};

        svg {
          fill: ${colors.mostlyWhite};
        }
      }
    }
  }

  &.soft-blue-outline-theme {
    .select-container {
      background-color: ${colors.white};
      border: solid 1px ${colors.softBlue};
      color: ${colors.softBlue};

      .icon {
        background-color: ${colors.white};

        svg {
          fill: ${colors.softBlue};
        }
      }
    }
  }

  &.grayish-blue-outline-theme {
    .select-container {
      background-color: ${colors.white};
      border: solid 1px ${colors.grayishBlue};
      color: ${colors.grayishBlue};

      .icon {
        background-color: ${colors.white};

        svg {
          fill: ${colors.grayishBlue};
        }
      }
    }
  }

  &.error-theme,
  &.with-error {
    .select-container {
      border: 1px solid ${colors.softRed};

      .icon {
        svg {
          fill: ${colors.softRed};
        }
      }
    }
  }

  &.rounded-shape {
    .select-container {
      border-radius: 8px;
    }
    .select-dropdown-menu {
        border-radius: 0 0 8px 8px;
    }
  }

  &.circle-shape {
    .select-container {
      border-radius: ${main.height.iphone / 2}px;
    }
    .select-dropdown-menu {
        border-radius: 8px;
    }
  }

  &.square-shape {
    .select-container {
      border-radius: 0;
    }
    .select-dropdown-menu {
        border-radius: 0;
    }
  }

  .select-container {
    border-radius: 8px;
    min-height: ${main.height.iphone}px;
    position: relative;
    cursor: pointer;

    overflow: visible; 

      &.is-open {
        border-bottom: none;
        
        &.rounded-shape {
            border-radius: 8px 8px 0 0; 
        }
        &.circle-shape {
            border-radius: ${main.height.iphone / 2}px ${main.height.iphone / 2}px 0 0; 
        }
        &.square-shape {
            border-radius: 0;
        }
    }

    .select-header {
      min-height: ${main.height.iphone}px;
      display: flex;
      align-items: center;
      padding-right: 60px;
      
      .selected-name {
          ${fontFamily.sourceSansPro.bold};
          font-size: 14px;
          line-height: 16px;
          overflow: hidden;
          padding: 16px 20px;
          white-space: nowrap;
          flex-grow: 1;
      }
    }

    .select-search-input {
      ${fontFamily.sourceSansPro.regular};
      font-size: 14px;
      line-height: 16px;
      border: none;
      outline: none;
      background: transparent;
      padding: 16px 20px;
      width: 100%;
      color: inherit;
    }
    
    .icon {
      align-items: center;
      border-radius: 0; 
      content: '';
      display: flex;
      height: 100%;
      justify-content: center;
      padding: 0 20px 0 16px;
      position: absolute;
      right: 0;
      top: 0;
      width: 52px;
      pointer-events: all;

      svg {
        display: block;
        height: auto;
        width: 100%;
        transition: transform 0.3s ease;
      }
    }

    &.is-open .icon svg {
        transform: rotate(180deg);
    }

    .select-element {
      ${zIndex.hills};
      cursor: pointer;
      height: 100%;
      left: 0;
      opacity: 0;
      position: absolute;
      top: 0;
      width: 100%;
      pointer-events: none; 
    }

    .select-dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        ${zIndex.hills};
        box-shadow: 0 6px 12px rgba(0,0,0,0.175);
        margin-top: 0;
        border-top: none; 
        background-color: ${colors.white};
        border: 1px solid ${colors.grayishBlue};
        
        &.dark-theme .select-dropdown-menu {
            background-color: ${colors.veryDarkGrayishBlue};
        }

        .select-options-list {
            list-style: none;
            padding: 0;
            margin: 0;
            max-height: 200px;
            overflow-y: auto;
        }

        .option-item {
            ${fontFamily.sourceSansPro.regular};
            font-size: 14px;
            padding: 10px 20px;
            cursor: pointer;
            color: ${colors.veryDarkGrayishBlue};
            background-color: ${colors.white};
            transition: background-color 0.2s;

            &:hover {
                background-color: ${colors.lightGrayishBlue};
            }

            &.selected {
                ${fontFamily.sourceSansPro.bold};
                background-color: ${colors.softBlue};
                color: ${colors.white};
            }

            &.no-results {
                cursor: default;
                font-style: italic;
                color: ${colors.grayishBlue};
                &:hover {
                    background-color: transparent;
                }
            }
        }
    }
  }

  .select-error {
    ${fontFamily.InputFieldStyle};
    background: transparent;
    border: none;
    color: ${colors.softRed};
    font-size: 12px;
    line-height: 20px;
  }
`;